import simpleLightbox from "simplelightbox";

export function lightbox() {
  new simpleLightbox(".image-gallery a", {
    captionsData: "alt",
    //captionPosition: "outside",
  });
}

export function objektSliderLightbox() {
  new simpleLightbox(".objekt__images-slider-item", {
    captionPosition: "outside",
  });
}
